module.exports = __webpack_public_path__ + "img/17.9fad05f9.png";